import React from 'react';
import { Link } from 'react-router-dom';
import { CelestialShell, SystemFooter } from './ui/CelestialShell';

const pages = {
  terms: {
    eyebrow: 'Legal',
    title: 'Terms of Service',
    body: 'Review the terms that govern access to and use of BrightResolve.',
    action: { href: '/policy/terms-of-service', label: 'Read the full Terms of Service' },
  },
  privacy: {
    eyebrow: 'Privacy',
    title: 'Privacy Policy',
    body: 'Review how BrightResolve describes data handling, privacy choices, and account rights.',
    action: { href: '/policy/privacy-policy', label: 'Read the full Privacy Policy' },
  },
  support: {
    eyebrow: 'Support',
    title: 'Help when you need it',
    body: 'For account access, privacy requests, or product support, contact the BrightResolve team. Do not include passwords or other secrets in your message.',
    action: { href: 'mailto:privacy@brightresolve.ai?subject=BrightResolve%20support', label: 'Contact support' },
  },
  contact: {
    eyebrow: 'Contact',
    title: 'Talk with BrightResolve',
    body: 'For privacy and account requests, use the secure contact address below. Include only the information needed to identify your request.',
    action: { href: 'mailto:privacy@brightresolve.ai?subject=BrightResolve%20request', label: 'privacy@brightresolve.ai' },
  },
};

export default function PublicInfoPage({ page }) {
  const content = pages[page] || pages.support;
  return (
    <CelestialShell className="br-info-page">
      <main className="br-container br-container--narrow br-info-layout">
        <section className="br-panel br-glass br-section br-info-card">
          <p className="br-eyebrow">{content.eyebrow}</p>
          <h1 className="br-page-title">{content.title}</h1>
          <p className="br-lead">{content.body}</p>
          <div className="br-info-actions">
            <a className="br-button br-button--primary" href={content.action.href}>{content.action.label}</a>
            <Link className="br-button" to="/">Return home</Link>
          </div>
        </section>
        <SystemFooter />
      </main>
    </CelestialShell>
  );
}
